import { Button, Modal } from "react-bootstrap";
import QrScanner from "../../abstract/qrScanner";
import { MouseEventHandler, ReactNode } from "react";

interface QrCodeScannerModalProps {
    show?: boolean;
    onDecode: (result: string) => void;
    onClose?: MouseEventHandler<HTMLButtonElement>;
}

const QrCodeScannerModal = (props: QrCodeScannerModalProps): ReactNode => {
    return (
        <Modal show={props.show}>
            <Modal.Header>
                <Modal.Title style={{ color: 'black' }}>Отсканировать QR-код</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <QrScanner onDecode={props.onDecode} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='light' onClick={props.onClose}>Отмена</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default QrCodeScannerModal;